import React, { useState, useEffect, useMemo } from "react";
import { Flex } from "@rebass/grid";
import styled from "styled-components";
import PlayerList from "./components/PlayerList";
import AddPlayerInput from "./components/AddPlayerInput";
import { space } from "styled-system";
import "./App.css";
import api from "./api/";

const StyledPlayerList = styled(PlayerList)`
  ${space}
`;

function App() {
  const players = usePlayers();
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      mx="auto"
      p="15px"
      css={{ maxWidth: 980 }}
    >
      <h1>NBA Player Statistics</h1>
      <AddPlayerInput />
      <StyledPlayerList mt={["10px", "40px"]} players={players} />
    </Flex>
  );
}

function usePlayers() {
  const [players, setPlayers] = useState();
  // initializing players
  useEffect(() => {
    api.getFavoritePlayers().then(players => setPlayers(players));
  }, []);
  // adjust to player changes
  useEffect(() => {
    const removePlayerChangeListener = api.addPlayersChangeListener(() =>
      api.getFavoritePlayers().then(players => setPlayers(players))
    );
    return removePlayerChangeListener;
  }, []);
  return players;
}

export default App;
